import { Typography } from '@statsbomb/kitbag-components';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { styled } from 'styled-components';
import themeHelper from '../../../utils/themeHelper';

const WarningContainer = styled.div`
  padding-bottom: ${themeHelper.spacing(0.5)};
  padding-left: ${themeHelper.spacing(0.5)};
`;

const END_BEFORE_START_MESSAGE = (
  <FormattedMessage
    defaultMessage="Period start must be before period end"
    id="60b1a"
  />
);

export function TimestampSelectionWarnings({ periodEnd, periodStart }) {
  return (
    <>
      {periodStart && periodEnd && periodEnd <= periodStart && (
        <WarningContainer>
          <Typography variant="bodyMedium" colour="highlight.main">
            {END_BEFORE_START_MESSAGE}
          </Typography>
        </WarningContainer>
      )}
    </>
  );
}

TimestampSelectionWarnings.propTypes = {
  periodEnd: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  periodStart: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
};

export default { TimestampSelectionWarnings };
